import React from "react";
import { Form, message } from "antd";
import { loginUser } from "../../../apicalls/users";
import { useDispatch } from "react-redux";
import { HideLoading, ShowLoading } from "../../../redux/loaderSlice";

function LoginPage() {
  const dispatch = useDispatch();
  const onFinish = async (values) => {
    try {
      dispatch(ShowLoading());
      const response = await loginUser(values);
      dispatch(HideLoading());
      if (response.success) {
        message.success(response.message);
        localStorage.setItem("token", response.data);
        window.location.href = "/";
      } else {
        message.error(response.message);
      }
    } catch (error) {
      dispatch(HideLoading());
      // Check if it's a network/connection error (backend not available)
      if (
        !error.response ||
        error.message?.includes("Backend server is not available")
      ) {
        message.error(
          "Cannot connect to server. Please ensure the backend is running.",
        );
      } else {
        message.error(error.message || "Login failed");
      }
    }
  };
  return (
    <div className="flex justify-center items-center h-screen w-screen bg-primary">
      <div className="card w-400 p-3 bg-white">
        <div className="flex flex-col">
          <img src="/logo.png" alt="logo" className="w-100" />
          <h1 className="text-2xl">
            Lubmbini Elite IT Quiz <i className="ri-login-circle-line"></i>
          </h1>
          <div className="divider"></div>
          <Form layout="vertical" className="mt-2" onFinish={onFinish}>
            <Form.Item name="email" label="Email">
              <input type="email" placeholder="Enter your email" required />
            </Form.Item>
            <Form.Item name="password" label="Password">
              <input
                type="password"
                placeholder="Enter your password"
                required
              />
            </Form.Item>
            <div className="flex flex-col gap-2">
              <button
                type="submit"
                className="primary-contained-btn mt-2 w-100"
              >
                Login
              </button>
              {/* <Link to="/register">Don't have an account? Register Here</Link> */}
            </div>
          </Form>
        </div>
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1,
            opacity: 0.7,
            fontSize: "15px",
            color: "#f9ffff",
            textAlign: "center",
            fontWeight: "400",
          }}
        >
          Powered By{" "}
          <a
            href="https://www.inovexmediatech.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontWeight: "900",
              color: "#009900",
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            Inovex Media and Tech
          </a>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
